import { Component } from '@angular/core';
import { MedrecordIcon } from '../../../base/medrecord-icon';

@Component({
  selector: 'medrecord-heart-minutes',
  templateUrl: './heart-minutes.component.svg',
  styleUrls: [],
})
export class HeartMinutesComponent extends MedrecordIcon {
  viewHeight: number = 24;
  viewWidth: number = 24;
}
